import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=4f932828&scoped=true&"
import script from "./NavLink.vue?vue&type=script&lang=ts&"
export * from "./NavLink.vue?vue&type=script&lang=ts&"
import style0 from "./NavLink.vue?vue&type=style&index=0&id=4f932828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f932828",
  null
  
)

export default component.exports